/**
 * Returns a number whose value is limited to the given range.
 * @param min The lower boundary of the output range
 * @param max The upper boundary of the output range
 */
export const clamp = (value: number, min: number, max: number) =>
{
    return value <= min ? min : value >= max ? max : value;
}

export function precision(a) {
    if (!isFinite(a)) return 0;
    var e = 1, p = 0;
    while (Math.round(a * e) / e !== a) { e *= 10; p++; }
    return p;
  }